import { type Message } from "instantdb/types";
import { type UIMessage } from "ai";

// Convert database Message to UIMessage format
export const convertToUIMessage = (message: Message): UIMessage => {
  const content = message.content || "";

  // Check if message has a linked file (for images)
  if (message.file && message.file.url) {
    return {
      id: message.id,
      role: message.role as "user" | "assistant",
      parts: [
        {
          type: "image",
          url: message.file.url,
        },
      ],
      metadata: {
        model: message.model,
        createdAt: message.createdAt,
        updatedAt: message.updatedAt,
        isImage: true,
        fileId: message.file.id,
      },
    };
  }

  // Check if content is an image URL (legacy support for blob URLs)
  const isImageContent =
    content.startsWith("blob:") || (content.startsWith("http") && content.includes("image"));

  // If it's an image URL, create an image part instead of text
  if (isImageContent) {
    return {
      id: message.id,
      role: message.role as "user" | "assistant",
      parts: [
        {
          type: "image",
          url: content,
        },
      ],
      metadata: {
        model: message.model,
        createdAt: message.createdAt,
        updatedAt: message.updatedAt,
        isImage: true,
      },
    };
  }

  return {
    id: message.id,
    role: message.role as "user" | "assistant",
    parts: [
      {
        type: "text",
        text: content,
      },
    ],
    metadata: {
      model: message.model,
      createdAt: message.createdAt,
      updatedAt: message.updatedAt,
    },
  };
};

